<div [ngClass]="isBanner?'slider-container_Banner': 'slider-container'">
  <ng-container *ngIf="mode === 'single'">
    <ng-container [ngTemplateOutlet]="singleImageView"></ng-container>
  </ng-container>

  <ng-container *ngIf="mode === 'multiple'">
    <ng-container *ngIf="!data || data?.length === 0; else multipleImageView">
      <ng-container [ngTemplateOutlet]="singleImageView"></ng-container>
    </ng-container>

    <ng-template #multipleImageView>
      <div [ngClass]="isBanner?'preview-navigation-container_Banner': 'preview-navigation-container'">
        <ng-container *ngIf="data">
          <button (click)="prev()" class="nav-button" kendoButton imageUrl="assets/icons/left_arrow_button.svg">
          </button>

          <div [ngClass]="isBanner?'preview-image-container_Banner': 'preview-image-container'" *ngIf="selectedImage">
            <img [src]="selectedImage" alt="Selected Image" [ngClass]="isBanner?'preview-image_Banner': 'preview-image'"
              *ngIf="selectedImage" />
            <button *ngIf="!viewMode" (click)="deleteImage(selectedImageData)" class="delete-button" kendoButton
              [id]="'Delete_banner_btn'" imageUrl="assets/icons/delet.svg" fillMode="none">
            </button>
          </div>
          <button (click)="next()" class="nav-button" kendoButton imageUrl="assets/icons/right_arrow_button.svg">
          </button>

          <div class="text-center fs-6">{{selectedIndex +1}} {{'of' | translate}} {{data?.length}}</div>
          <div class="text-center error-msg" *ngIf="errorMessages.length>0">{{ errorMessages.join(', ') }}
          </div>
        </ng-container>
      </div>

      <div class="thumbnail-container">
        <ng-container [ngTemplateOutlet]="kendoUploader" [ngTemplateOutletContext]="{view: 'small'}"></ng-container>

        <div [ngClass]="isBanner ? 'thumbnail-list_Banner' : 'thumbnail-list'">
          <div *ngFor="let image of data; let i = index" (click)="selectImage(image, i)" class="thumbnail"
          [ngClass]="{ 'selected-thumbnail': i === selectedIndex && !isBanner,'selected-thumbnail_Banner':i === selectedIndex && isBanner }">
            <img [src]="sanitizer.bypassSecurityTrustResourceUrl(src + image[this.keyId])" alt="Thumbnail"
              class="thumbnail-image" />
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>

<ng-template #kendoUploader let-view="view">
  <div  *ngIf="!viewMode" (click)="onclick()" kendoUploadDropZone="myZone" [class]="'uploader-container uploader-container--' + view">
    <img [src]="'assets/icons/add_black_24dp.svg'">
    <ng-container *ngIf="view === 'large'">
      <span class="text">
        {{ 'AddPhoto' | translate }}
      </span>
      <span class="restrictions">
        {{(uploadRestrictions?.allowedExtensions)}}
      </span>
    </ng-container>
  </div>

  <div [id]="'id_upload_area'+DomID" class="d-none">
    <kendo-upload #fileUploader [restrictions]="uploadRestrictions" [saveUrl]="saveURL" [withCredentials]="false"
      (select)="onSelectImg($event,fileUploader)" zoneId="myZone" (success)="imageAddedSuccessfully($event)"
      (uploadProgress)="uploadProgressEventHandler($event)" [autoUpload]="false">
    </kendo-upload>
  </div>
</ng-template>

<ng-template #singleImageView>
  <ng-container [ngTemplateOutlet]="kendoUploader" [ngTemplateOutletContext]="{view: 'large'}"
    *ngIf="data?.length === 0 && !selectedImage"></ng-container>
  <div class="error-msg" *ngIf="errorMessages.length>0">{{ errorMessages.join(', ') }}</div>
  <ng-container *ngIf="selectedImage">
    <div class="preview-image-container preview-image-container--large">
      <img [src]="selectedImage" alt="Selected Image" class="preview-image" />
      <button (click)="deleteImage(selectedImageData)" class="delete-button" kendoButton [id]="'Delete_banner_btn'"
        imageUrl="assets/icons/delet.svg" fillMode="none">
      </button>
    </div>
  </ng-container>
</ng-template>